import { useStreamEffect } from 'annotation-tools/utils';
import React, { Fragment, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchKoumutenList } from '../global-state/database/koumuten-list';
import { fetchUserList } from '../global-state/database/user-list';
import { pathList$, updatePathname } from '../global-state/router-pathname';
import { pathnameElements } from './routes';
import { updateIdWithPathlist } from './update-id-by-pathlist';

export const PathnameListener = () => {
  const history = useHistory();
  useEffect(() => {
    updatePathname(history.location.pathname);
    history.listen(location => updatePathname(location.pathname));
  }, [history]);

  useStreamEffect(pathList$, pathlist => {
    updateIdWithPathlist(pathlist);

    if (pathlist.length === 1) {
      switch (pathlist[0]) {
        case pathnameElements.users:
          fetchUserList();
          break;
        case pathnameElements.koumutens:
          fetchKoumutenList();
          break;
        default:
          break;
      }
    }
  });

  return <Fragment />;
};
